import React, { Component } from 'react';
import './styles.css';

class ProcurementSupplierLayout extends Component {
	render() {
		return (
			<div className="procurement-supplier-layout">{this.props.children}</div>
		);
	}
}

export default ProcurementSupplierLayout;
